var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAtlassianOriginal = function SvgAtlassianOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_AtlassianOriginal__paint0_linear_19_30063)",
    d: "M5.74 8.968c-.293-.322-.733-.293-.938.088L.055 18.58c-.175.381.088.82.498.82h6.623c.205 0 .41-.117.498-.322 1.436-2.959.556-7.442-1.934-10.109"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M9.228.295c-2.666 4.22-2.49 8.879-.732 12.395s3.106 6.182 3.194 6.388a.54.54 0 0 0 .498.322h6.622c.41 0 .703-.44.498-.82 0 0-8.908-17.816-9.142-18.255-.176-.41-.674-.44-.938-.03"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_AtlassianOriginal__paint0_linear_19_30063",
    x1: 8.339,
    x2: 3.32,
    y1: 10.424,
    y2: 19.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#2684FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAtlassianOriginal);
export { ForwardRef as ReactComponent };